import React, {useState,useEffect} from 'react'
import styled from "styled-components"
import {getInfo, logout} from "../other/user_info"
import  {useHistory}  from 'react-router-dom'
import {useSelector, useDispatch} from "react-redux"
import {setH24} from "../actions/h24"
import "./MainMenu/MainMenu.css"

const Container = styled.div`
    background: radial-gradient(circle, rgba(20,30,48,1) 0%, rgba(36,59,85,1) 100%);
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
`

const AccountCard = styled.div`
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 40px;
    width: 600px;
    box-shadow: 0 20px 50px rgba(0,0,0,0.5);
    color: white;
    text-align: center;
    animation: slideUp 0.5s ease-out;

    @keyframes slideUp {
        from { opacity: 0; transform: translateY(30px); }
        to { opacity: 1; transform: translateY(0); }
    }
`

const Avatar = styled.div`
    width: 80px;
    height: 80px;
    background: #00d2ff;
    border-radius: 50%;
    margin: 0 auto 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.5rem;
    box-shadow: 0 0 20px rgba(0, 210, 255, 0.4);
`

const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px;
    margin-top: 30px;
    text-align: left;
`

const InfoItem = styled.div`
    background: rgba(255, 255, 255, 0.03);
    padding: 15px 20px;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-left: 4px solid #00d2ff;

    span.label { color: rgba(255,255,255,0.5); font-size: 0.9rem; text-transform: uppercase; letter-spacing: 1px; }
    span.value { font-weight: bold; font-size: 1.1rem; color: #fff; }
`

const ActionButtons = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 40px;
`

const Button = styled.button`
    flex: 1;
    padding: 15px;
    border-radius: 12px;
    border: none;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 1px;
    outline: none;

    &.back { background: rgba(255,255,255,0.1); color: white; }
    &.logout { background: #e74c3c; color: white; }

    &:hover, &:focus {
        transform: translateY(-3px);
        filter: brightness(1.2);
        box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    }
`

const AccountInfo = () => {
    const [style, setStyle] = useState();
    const info = getInfo();
	const history = useHistory();
    const dispatch = useDispatch()
    const h24 = useSelector(state => state.h24)

    useEffect(() => {
		setStyle("nav-active");
        const backBtn = document.querySelector(".back");
        if(backBtn) backBtn.focus();
    },[]);

    const back = () =>{
        history.push("/");
	}

    // Formata a data para algo legível em PT-BR
    const expiryDate = new Date(info.expiry).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    return (
        <Container className={style}>
            <AccountCard>
                <Avatar><i className="fas fa-user"></i></Avatar>
                <h2 style={{margin: 0}}>Minha Conta</h2>
                <p style={{color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem'}}>Informações de assinatura</p>

                <InfoGrid>
                    <InfoItem>
                        <span className="label">Usuário</span>
                        <span className="value">{info.username}</span>
                    </InfoItem>
                    <InfoItem>
                        <span className="label">Conexões Ativas</span>
                        <span className="value">{info.active_cons} / {info.max_connections}</span>
                    </InfoItem>
                    <InfoItem>
                        <span className="label">Vencimento</span>
                        <span className="value" style={{color: '#2ecc71'}}>{expiryDate}</span>
                    </InfoItem>
                    <InfoItem>
                        <span className="label">Status</span>
                        <span className="value" style={{textTransform: 'uppercase'}}>{info.status === 'Active' ? 'Ativo' : info.status}</span>
                    </InfoItem>
                </InfoGrid>

                <div style={{marginTop: '20px', textAlign: 'left', display: 'flex', alignItems: 'center'}}>
                    <input 
                        type="checkbox" 
                        id="h24"
                        style={{width: '20px', height: '20px', marginRight: '10px'}}
                        defaultChecked={h24==="HH:MM"} 
                        onChange={()=>dispatch(setH24(h24!=="HH:MM"))}
                    />
                    <label htmlFor="h24" style={{cursor: 'pointer', fontSize: '0.9rem'}}>Usar formato de 24 horas no relógio</label>
                </div>

                <ActionButtons>
                    <Button className="back" onClick={back}>Voltar</Button>
                    <Button className="logout" onClick={logout}>Sair da Conta</Button>
                </ActionButtons>
            </AccountCard>
        </Container>
    )
}

export default AccountInfo
